import { RestartAltOutlined } from '@mui/icons-material';
import { Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '@/legacy/common/types';
import { useConversationContext } from '@/legacy/components/ConversationContextProvider/ConversationContextProvider.hook';
import { useExtensionPurchaseReqNumberSelector } from '@/legacy/components/ExtensionPurchaseRequisitionNumber/extensionPurchaseReqNumberActor';

export const DemandConversationPageHeaderForExtension = () => {
  const { t } = useTranslation(I18nNamespace.conversation, { keyPrefix: 'DemandConversation' });

  const { status, reset } = useConversationContext();
  const previousPurchaseReqNumber = useExtensionPurchaseReqNumberSelector(
    (state) => state.context.previousPurchaseReqNumber,
  );

  return (
    <>
      <Stack flexDirection="row" alignItems="center" justifyContent="space-between" paddingX={2} paddingY={1}>
        <Typography variant="h6">
          {t('title')}
          {previousPurchaseReqNumber ? ` (${previousPurchaseReqNumber})` : ''}
        </Typography>
        <Stack flexDirection="row" alignItems="center">
          <Tooltip title={t('action.reset')}>
            <IconButton disabled={status === 'loading'} onClick={reset}>
              <RestartAltOutlined />
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>
      <Divider />
    </>
  );
};
